LabelCeController.$inject = ['$stateParams', 'notification'];

export default function LabelCeController($stateParams, notification) {}
